// Helper for the sidebar view-perspective toggle ("Växla till användare/admin").
//
// The perspective toggle must be reachable on every screen size, in BOTH directions:
// an admin needs to switch to the user view to open the TriageViewer, and to switch
// back to the admin view afterwards — on mobile as well as desktop (BAS-13619). It must
// therefore never carry the `not-available-for-small-screens` class
// (see src/style/responsive/mobile.scss), which hides elements below 767px.
export const VIEW_TOGGLE_BASE_CLASS = 'sidenavItem';
export const NOT_AVAILABLE_FOR_SMALL_SCREENS_CLASS = 'not-available-for-small-screens';

// Returns the className for the view-toggle item. Always visible across screen sizes.
export const getViewToggleClassName = () => VIEW_TOGGLE_BASE_CLASS;
